export default __webpack_public_path__ + "static/media/tennis.2b3bd0d3.jpg";